import { ActionTree } from 'vuex'
import { UserManagementStateInterface } from '@/models/store/UserManagementState.interface'
import { RootStateInterface } from '@/models/store/RootState.interface'
import { Role } from '@/models/users/User.interface'
import { fetchUsers, fetchFeatures, updateUserPermissions } from '@/api_client'

const actions: ActionTree<UserManagementStateInterface, RootStateInterface> = {
  async load({ commit }) {
    commit('loading')
    try {
      const [usersResponse, featuresResponse] = await Promise.all([
        fetchUsers(),
        fetchFeatures()
      ])
      commit('updateUsers', usersResponse.data)
      commit('updateFeatures', featuresResponse.data)
    } finally {
      commit('loaded')
    }
  },
  async updatePermissions(
    { commit, rootState },
    { id, permissions }: { id: string; permissions: Record<string, Role> }
  ) {
    commit('saving')
    try {
      const response = await updateUserPermissions({ id, permissions })

      // If you edited your own roles, refresh the auth store so the UI's
      // permission gating updates immediately — in development there is no
      // re-login to pull the new permission map.
      if (response?.data && rootState.auth.user?.id === id) {
        commit('auth/setUser', response.data, { root: true })
      }

      return response
    } finally {
      commit('saved')
    }
  }
}

export default actions
